module.exports = __webpack_public_path__ + "static/img/pinpai-9.1c0c1535.png";